import _slicedToArray from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "confirm-order-wrap"
};
var _hoisted_2 = {
  class: "link-panel-content"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  key: 2,
  class: "address-info"
};
var _hoisted_5 = {
  class: "address-info-name"
};
var _hoisted_6 = {
  class: "address-info-address"
};
var _hoisted_7 = {
  class: "distance"
};
var _hoisted_8 = {
  class: "delivery-info"
};
var _hoisted_9 = {
  key: 3,
  class: "address-info"
};
var _hoisted_10 = {
  class: "address-info-name"
};
var _hoisted_11 = {
  class: "address-info-address"
};
var _hoisted_12 = {
  class: "delivery-info"
};
var _hoisted_13 = {
  class: "panel"
};
var _hoisted_14 = {
  class: "header"
};
var _hoisted_15 = {
  class: "panel-content-row"
};
var _hoisted_16 = {
  class: "form-item form-item-row"
};
var _hoisted_17 = {
  class: "form-item-content"
};
var _hoisted_18 = {
  class: "form-item form-item-row"
};
var _hoisted_19 = {
  class: "form-item-content"
};
var _hoisted_20 = {
  class: "panel item-panel"
};
var _hoisted_21 = {
  class: "header"
};
var _hoisted_22 = {
  class: "item-else"
};
var _hoisted_23 = {
  class: "info-label"
};
var _hoisted_24 = {
  class: "info-value"
};
var _hoisted_25 = {
  class: "detial-info"
};
var _hoisted_26 = {
  class: "info-label"
};
var _hoisted_27 = {
  key: 0,
  class: "select-voucher-selected"
};
var _hoisted_28 = {
  class: "coupon-reward"
};
var _hoisted_29 = {
  key: 0,
  class: "select-voucher select-voucher--selectable"
};
var _hoisted_30 = {
  key: 1,
  class: "select-voucher"
};
var _hoisted_31 = {
  class: "detial-info"
};
var _hoisted_32 = {
  class: "info-label info-label--large"
};
var _hoisted_33 = {
  class: "info-value info-value--large"
};
var _hoisted_34 = {
  class: "panel"
};
var _hoisted_35 = {
  class: "header"
};
var _hoisted_36 = {
  class: "panel-content panel-content-p-14"
};
var _hoisted_37 = {
  class: "confirm-shop"
};
var _hoisted_38 = {
  key: 0
};
var _hoisted_39 = {
  class: "delivery-user-info"
};
var _hoisted_40 = {
  class: "main-info-wrap"
};
var _hoisted_41 = {
  class: "delivery-shop-name"
};
var _hoisted_42 = {
  key: 1
};
var _hoisted_43 = {
  class: "pickup-shop-info"
};
var _hoisted_44 = {
  class: "pickup-shop-name"
};
var _hoisted_45 = {
  class: "pickup-distance"
};
var _hoisted_46 = {
  class: "main-info-wrap"
};
var _hoisted_47 = {
  class: "pickup-user-info"
};
var _hoisted_48 = {
  class: "page-bottom"
};
var _hoisted_49 = {
  class: "cart-info"
};
var _hoisted_50 = {
  class: "cart-info-label"
};
var _hoisted_51 = {
  class: "cart-info-value"
};
var _hoisted_52 = {
  key: 0,
  class: "user-terms-wrap"
};
var _hoisted_53 = {
  class: "user-terms"
};
var _hoisted_54 = {
  class: "user-terms"
};
var _hoisted_55 = {
  class: "bottom-button-wrap"
};
import { computed, onMounted, reactive, ref, watch, nextTick } from "vue";
import Button from "@/components/base/Button.vue";
import { priceUtil } from "@op/shared";
import { useCartStore } from "@/store/cartStore";
import { createOrderDishesItems, calcSelectCouponList } from "@/composable/useOrder";
import { cloneDeep } from "lodash-es";
import { createDeliveryOrder, createDeliveryOrderOnlinePay } from "@/api/order";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { showToast } from "@/utils/toastUtil";
import { useRouter } from "@/hooks/useRouter";
import SvgIcon from "@/components/base/SvgIcon.vue";
import Input from "@/components/base/Input.vue";
import PaymentMethodVue from "@/components/order/PaymentMethod.vue";
import { useAddressStoreWithOut } from "@/store/addressStore";
import { formatLocation } from "@/utils/format";
import { useUserStoreWithOut } from "@/store/userStore";
import { useOrderListStore } from "@/store/orderListStore";
import { useAddress } from "@/hooks/useAddress";
import { formatDistance } from "@/utils/format";
import { calcDeliveryOrderAmount } from "@/api/order";
import { formatDateWithTZ } from "@/utils/format";
import Common from "@/components/dialog/src/Common.vue";
import PoweredBy from "@/components/PoweredBy.vue";
import PreparingInfo from "@/components/shop/PreparingInfo.vue";
import Dialog from "@/components/dialog/dialog";
import { times, divide, plus } from "@/utils/mathUtil";
import SelectCouponList from "@/components/coupon/SelectCouponList.vue";
// import { getUnusedUserCouponListRes } from "@/components/coupon/tempCouponData";
import { getUserCouponList } from "@/api/reward";
import { getUserId, getSupplyId } from "@/utils/authUtil";
import { SHOP_UNSUPPORT_DELIVERY, SHOP_BUSY, SHOP_NOT_IN_BUSINESS_STATUS, DISHES_ORDER_ITEM_INVALID, COUPON_NOT_MATCH_MINIMUM_AMOUNT, COUPON_NOT_MATCH_DISHES, VOUCHER_CODE_CANNOT_USE } from "@/constant/responseCode";
import { useSupplierStore } from "@/store/supplierStore";
import { DiscountTypeEnum } from "@/constant/coupon";
import { useRoute } from "vue-router";
import CartItems from "./components/CartItems.vue";
import { debounce } from "lodash-es";
import { handleFeeDetail, createOnlinePay } from "@op/shared";
import { useShopStore } from "@/store/shopStore";
import { calcDishTagList } from "@/composable/useDishes";
import OutOfStockDialog from "@/components/menu/OutOfStockDialog.vue";
import { useI18n } from "vue-i18n";
import { convertPoint2Price, convertPrice2Points, floorPriceByPointsPaymentRule, isProd, toCalSubCharge } from "@/utils/tools";
import Checkbox from "@/components/base/Checkbox.vue";
import { Persistent } from "@/utils/cache/persistent";
import { SESSION_KEY_CART_COUPON, SESSION_KEY_CART_VOUCHER_CODE, SESSION_KEY_CART_POINTS, SESSION_KEY_CUSTOMER_REMARK, SESSION_KEY_IS_PRIVACY_POLICY_CHECKED, SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE, SESSION_KEY_IS_USER_TERMS_CHECKED, SESSION_KEY_SELECTED_PAYMENT_METHOD, SESSION_KEY_CART_VOUCHER_CODE_DETAIL } from "@/constant/storageKey";
import { getCurrentLocaleValue } from "@/lang";
import { LangEnum } from "../../constant/lang";
import { Notify } from "@/utils/notifyUtil";
import PayWithPoints from "./components/PayWithPoints.vue";
import { useDeliveryFeeAndTime } from "@/hooks/useCart";
export default {
  __name: 'ConfirmOrder',
  setup: function setup(__props) {
    var orderpinH5Host = process.env.VUE_APP_ORDERPIN_H5_HOST;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var cartStore = useCartStore();
    var shopStore = useShopStore();
    var orderListStore = useOrderListStore();
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush,
      routerBack = _useRouter.routerBack;
    var route = useRoute();
    var addressStore = useAddressStoreWithOut();
    var userStore = useUserStoreWithOut();
    var supplierStore = useSupplierStore();
    var _useAddress = useAddress(),
      getSelfPickUpDistance = _useAddress.getSelfPickUpDistance,
      getSelfDeliveryDistance = _useAddress.getSelfDeliveryDistance;
    var _useDeliveryFeeAndTim = useDeliveryFeeAndTime(),
      getDeliveryFeeAndTime = _useDeliveryFeeAndTim.getDeliveryFeeAndTime;
    var shopData = computed(function () {
      return shopStore.getShopData;
    });
    var deliveryMethod = computed(function () {
      return userStore.getOrderType;
    });

    // 优惠券、礼品卡、积分抵扣
    var selectedCoupon = computed(function () {
      return cartStore.getCoupon;
    });
    var voucherCodeDetail = computed(function () {
      return cartStore.voucherCodeDetail;
    });
    var selectedVoucherCode = computed(function () {
      return cartStore.getVoucherCode;
    });
    var selectedPoints = computed(function () {
      return cartStore.getPoints;
    });
    var paymentMethodRef = ref();

    // 自提表单数据
    var pickUpTime = ref("now");
    var customerName = computed({
      get: function get() {
        return userStore.getCustomerInputName;
      },
      set: function set(val) {
        userStore.setCustomerInputName(val);
      }
    });
    var customerMobile = computed({
      get: function get() {
        return userStore.getCustomerInputMobile;
      },
      set: function set(val) {
        userStore.setCustomerInputMobile(val);
      }
    });
    // 自配送表单数据
    var selectedAddress = computed(function () {
      return addressStore.getSelectedAddress;
    });
    var selfDeliveryFormData = reactive({
      deliveryTime: 0,
      deliveryFee: 0,
      startingFee: 0
    });
    // 自提、自配送表单数据
    var customerRemark = ref("");
    var paymentMethod = ref(null);
    var isShowPrivacyPolicyAndUserTerms = computed(function () {
      return supplierStore.getCountry === "IL";
    });
    var privacyPolicyAndUserTermsLang = computed(function () {
      var langMap = _defineProperty(_defineProperty({}, LangEnum.EN_US, "en"), LangEnum.HE_IL, "he");
      var currentLocaleValue = getCurrentLocaleValue();
      return langMap[currentLocaleValue] || langMap[LangEnum.EN_US];
    });
    var isPrivacyPolicyChecked = ref(false);
    var isUserTermsChecked = ref(false);

    // 自配送展示数据
    var formatedSelfDeliveryTime = computed(function () {
      return selfDeliveryFormData.deliveryTime || 0;
    });
    var deliveryDistance = ref(NaN);
    var deliveryPackingFee = ref(0);
    // 自提展示数据
    var pickupDistance = ref(NaN);
    var mealPrepareTime = ref(0);
    var formatedPickupAt = computed(function () {
      return formatDateWithTZ(Date.now() + mealPrepareTime.value * 60 * 1000, "hh:mmA");
    });
    // 自提、自配送展示数据
    var cartList = computed(function () {
      return cartStore.getCart;
    });
    function handleUpdateCount(cartIndex, num) {
      cartStore.changeNum(cartIndex, num);
      nextTick(function () {
        if (cartList.value.length === 0) {
          setTimeout(function () {
            routerBack();
          }, 300);
        } else {
          isCalced.value = false;
          debounceCalcDeliveryOrder();
        }
      });
    }
    var currency = computed(function () {
      return cartStore.getCartItemCurrency;
    });
    var userCouponList = ref([]);
    var selectCouponList = computed(function () {
      return calcSelectCouponList({
        userCouponList: cloneDeep(userCouponList.value),
        grandTotal: isFareV2.value ? totalPriceExcTax.value : grandTotal.value,
        deliveryMethod: deliveryMethod.value,
        cartList: cartList.value
      });
    });
    var canuseSelectCouponList = computed(function () {
      return selectCouponList.value.filter(function (item) {
        return !item.cannot_use;
      });
    });
    var couponTotal = ref(0);
    var grandTotal = ref(0);

    // 优惠券扣减的金额
    var couponReduceAmount = computed(function () {
      if (selectedCoupon.value && !isFareV2.value) {
        // 优惠券面向分类使用时，计算优惠券金额时以满足条件的分类下的菜品的总金额为准；优惠券面向菜品使用时，计算优惠券金额时以满足条件的菜品的总金额为准
        var scopeDishesIds = [];
        if (selectedCoupon.value.coupon.dishes_scope.scope_type === "category") {
          var scopeCategoryids = selectedCoupon.value.coupon.dishes_scope.scope_ids || [];
          var dishesCategory = shopStore.getDishesCategory;
          var _scopeDishesIds = [];
          dishesCategory.filter(function (cateItem) {
            return scopeCategoryids.includes(cateItem.category_id);
          }).forEach(function (cateItem) {
            var _cateItem$dishes_list;
            (_cateItem$dishes_list = cateItem.dishes_list) === null || _cateItem$dishes_list === void 0 || _cateItem$dishes_list.forEach(function (dishItem) {
              _scopeDishesIds.push(dishItem.id);
            });
          });
          scopeDishesIds = _toConsumableArray(new Set(_scopeDishesIds));
        } else if (selectedCoupon.value.coupon.dishes_scope.scope_type === "dishes") {
          scopeDishesIds = selectedCoupon.value.coupon.dishes_scope.scope_ids || [];
        }
        if (selectedCoupon.value.coupon.discount_type === DiscountTypeEnum.FIXED) {
          var reduceAmount = 0;
          if (scopeDishesIds.length) {
            var matchedDishesTotalAmount = parseInt(cartList.value.reduce(function (prev, cartItem) {
              if (scopeDishesIds.includes(cartItem.id)) {
                return plus(prev, times(cartItem.selectedPrice, cartItem.num));
              } else {
                return prev;
              }
            }, 0));
            // 优惠券扣减的金额不能大于匹配菜品的总金额
            reduceAmount = selectedCoupon.value.coupon.discount_rule.discount > matchedDishesTotalAmount ? matchedDishesTotalAmount : selectedCoupon.value.coupon.discount_rule.discount;
          } else {
            reduceAmount = selectedCoupon.value.coupon.discount_rule.discount;
          }
          return reduceAmount;
        } else if (selectedCoupon.value.coupon.discount_type === DiscountTypeEnum.PERCENT) {
          var _reduceAmount = 0;
          if (scopeDishesIds.length) {
            _reduceAmount = parseInt(cartList.value.reduce(function (prev, cartItem) {
              if (scopeDishesIds.includes(cartItem.id)) {
                return plus(prev, times(times(cartItem.selectedPrice, cartItem.num), selectedCoupon.value.coupon.discount_rule.discount_percent));
              } else {
                return prev;
              }
            }, 0));
          } else {
            _reduceAmount = parseInt(times(grandTotal.value, selectedCoupon.value.coupon.discount_rule.discount_percent));
          }
          if (selectedCoupon.value.coupon.discount_rule.max_discount > 0 && _reduceAmount > selectedCoupon.value.coupon.discount_rule.max_discount) {
            _reduceAmount = selectedCoupon.value.coupon.discount_rule.max_discount;
          }
          return _reduceAmount;
        } else {
          return 0;
        }
      } else if (selectedCoupon.value && isFareV2.value) {
        return couponTotal.value;
      } else {
        return 0;
      }
    });
    // 礼品卡可用的总余额
    var voucherCodeBalance = computed(function () {
      return selectedVoucherCode.value ? selectedVoucherCode.value.balance : 0;
    });
    // 积分抵扣可用的总余额
    var pointsBalance = computed(function () {
      return selectedPoints.value ? priceUtil.tranferPriceToBaseUnit(convertPoint2Price(userStore.getPoints, selectedPoints.value), currency.value) : 0;
    });
    // 礼品卡扣减的金额
    var voucherCodeReduceAmount = computed(function () {
      // if (selectedVoucherCode.value && selectedPoints.value) {
      //   // 共同使用时，先选中的优先抵扣
      //   if (
      //     selectedVoucherCode.value._selectTime < selectedPoints.value._selectTime
      //   ) {
      //     // 先选中礼品卡
      //     return Math.min(
      //       voucherCodeBalance.value,
      //       computedGrandTotalAfterFixedAmount.value
      //     );
      //   } else {
      //     // 先选中积分
      //     return Math.min(
      //       voucherCodeBalance.value,
      //       computedGrandTotalAfterFixedAmount.value -
      //         priceUtil.tranferPriceToBaseUnit(
      //           floorPriceByPointsPaymentRule(
      //             priceUtil.tranferBaseUnitToPrice(
      //               Math.min(
      //                 pointsBalance.value,
      //                 computedGrandTotalAfterFixedAmount.value
      //               ),
      //               currency.value
      //             ),
      //             userStore.getPoints,
      //             selectedPoints.value
      //           )
      //         )
      //     );
      //   }
      // }
      if (selectedVoucherCode.value) {
        return Math.min(voucherCodeBalance.value, computedGrandTotalAfterFixedAmount.value);
      } else {
        return 0;
      }
    });
    // 积分扣减的金额
    var pointsReduceAmount = computed(function () {
      var res = 0;

      // if (selectedVoucherCode.value && selectedPoints.value) {
      //   // 共同使用时，先选中的优先抵扣
      //   if (
      //     selectedPoints.value._selectTime < selectedVoucherCode.value._selectTime
      //   ) {
      //     // 先选中积分
      //     res = Math.min(
      //       pointsBalance.value,
      //       computedGrandTotalAfterFixedAmount.value
      //     );
      //   } else {
      //     // 先选中礼品卡
      //     res = Math.min(
      //       pointsBalance.value,
      //       Math.max(
      //         computedGrandTotalAfterFixedAmount.value - voucherCodeBalance.value,
      //         0
      //       )
      //     );
      //   }
      // }
      if (selectedPoints.value) {
        res = Math.min(pointsBalance.value, computedGrandTotalAfterFixedAmount.value);
      } else {
        res = 0;
      }
      return selectedPoints.value ? priceUtil.tranferPriceToBaseUnit(floorPriceByPointsPaymentRule(priceUtil.tranferBaseUnitToPrice(res, currency.value), userStore.getPoints, selectedPoints.value)) : 0;
    });

    // 经过优惠券、卡手续费等固定费用（固定金额或固定比例）计算后的应付金额
    var computedGrandTotalAfterFixedAmount = computed(function () {
      var _paymentMethod$value;
      var res = grandTotal.value;
      var subChargeRate = (_paymentMethod$value = paymentMethod.value) === null || _paymentMethod$value === void 0 || (_paymentMethod$value = _paymentMethod$value.subCharge) === null || _paymentMethod$value === void 0 ? void 0 : _paymentMethod$value.rate;
      if (couponReduceAmount.value > 0 && !isFareV2.value) {
        res = res - couponReduceAmount.value;
      }
      if (subChargeRate) {
        var _toCalSubCharge;
        res += (_toCalSubCharge = toCalSubCharge(res, subChargeRate)) !== null && _toCalSubCharge !== void 0 ? _toCalSubCharge : 0;
      }
      return res;
    });
    /**
     * 经过礼品卡、积分等动态费用（能全额抵扣订单金额，共同使用时此消彼长）计算后的应付金额
     * 20251029补充：礼品卡和积分共同使用，并且订单金额抵扣为0时，订单缺少支付方式，暂时不允许共同使用
     */
    var computedGrandTotal = computed(function () {
      var res = computedGrandTotalAfterFixedAmount.value;
      if (voucherCodeReduceAmount.value) {
        res = res - voucherCodeReduceAmount.value;
      } else if (pointsReduceAmount.value) {
        res = res - pointsReduceAmount.value;
      }
      return Math.max(res, 0);
    });

    // 开关控制数据
    var isCalced = ref(false);
    var isSubmit = ref(false);

    // 税费相关
    var isSelfDeliveryFormDataInvalid = computed(function () {
      return deliveryMethod.value === "self_delivery" && !selectedAddress.value;
    });
    var contactPersonErrorMsg = computed(function () {
      if (deliveryMethod.value === "self_pick_up") {
        if (!customerName.value || !customerMobile.value) {
          return t("pleaseFillInTheInformation");
        } else if (customerMobile.value.length < 7) {
          return t("pleaseEnterTheCorrectTel");
        } else {
          return "";
        }
      } else {
        return "";
      }
    });
    var startingPrice = computed(function () {
      return selfDeliveryFormData.startingFee || 0;
    });
    var allowReload = computed(function () {
      var _supplierStore$getSup, _supplierStore$getSup2;
      return (_supplierStore$getSup = (_supplierStore$getSup2 = supplierStore.getSupplierTopUpSetting) === null || _supplierStore$getSup2 === void 0 ? void 0 : _supplierStore$getSup2.allow_top_up_at_mini_program) !== null && _supplierStore$getSup !== void 0 ? _supplierStore$getSup : true;
    });
    var isSubmitButtonDisabled = computed(function () {
      var _paymentMethod$value2, _paymentMethod$value3, _paymentMethodRef$val;
      return cartList.value.length <= 0 || deliveryMethod.value === "self_delivery" && cartStore.getCartTotalPrice < startingPrice.value || !isCalced.value || isSubmit.value || !((_paymentMethod$value2 = paymentMethod.value) !== null && _paymentMethod$value2 !== void 0 && _paymentMethod$value2.value) && !((selectedVoucherCode.value || selectedPoints.value) && computedGrandTotal.value === 0) || isSelfDeliveryFormDataInvalid.value || ((_paymentMethod$value3 = paymentMethod.value) === null || _paymentMethod$value3 === void 0 ? void 0 : _paymentMethod$value3.method) === "balance" && userStore.getWallet < computedGrandTotal.value && (!allowReload.value || ((_paymentMethodRef$val = paymentMethodRef.value) === null || _paymentMethodRef$val === void 0 ? void 0 : _paymentMethodRef$val.onlinePaymentOptions.length) <= 0) || isShowPrivacyPolicyAndUserTerms.value && !(isPrivacyPolicyChecked.value && isUserTermsChecked.value);
    });
    var submitButtonText = computed(function () {
      var _paymentMethod$value4;
      if (((_paymentMethod$value4 = paymentMethod.value) === null || _paymentMethod$value4 === void 0 ? void 0 : _paymentMethod$value4.method) === "balance" && userStore.getWallet < computedGrandTotal.value) {
        var _paymentMethodRef$val2;
        // 选择余额且余额不足
        if (!allowReload.value) {
          return t("insufficientBalance");
        } else if (((_paymentMethodRef$val2 = paymentMethodRef.value) === null || _paymentMethodRef$val2 === void 0 ? void 0 : _paymentMethodRef$val2.onlinePaymentOptions.length) > 0) {
          return t("insufficientBalancePleaseTopUp");
        } else {
          return t("notEnoughBalancePleaseTopUpInStore");
        }
      } else if (deliveryMethod.value === "self_delivery" && cartStore.getCartTotalPrice < startingPrice.value) {
        return t("minimumSpendN", [priceUtil.formatBaseUnitToShowPrice(startingPrice.value, currency.value)]);
      } else {
        return t("orderNow");
      }
    });
    var isFareV2 = computed(function () {
      var _shopStore$getShopDat;
      return (_shopStore$getShopDat = shopStore.getShopData) === null || _shopStore$getShopDat === void 0 || (_shopStore$getShopDat = _shopStore$getShopDat.feature_setting) === null || _shopStore$getShopDat === void 0 ? void 0 : _shopStore$getShopDat.fare_v2;
    });
    // 订单试算
    var feeList = ref([]);
    function calcDeliveryOrder() {
      return _calcDeliveryOrder.apply(this, arguments);
    }
    function _calcDeliveryOrder() {
      _calcDeliveryOrder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _selectedCoupon$value, _selectedCoupon$value2;
        var dishesItems, calcRes, _calcRes$data, _calcRes$data2, _calcRes$data3, dishes;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              isCalced.value = false;
              dishesItems = createOrderDishesItems(cloneDeep(cartList.value));
              _context3.next = 4;
              return calcDeliveryOrderAmount({
                dishes_items: dishesItems,
                shop_id: shopStore.getShopId,
                type: deliveryMethod.value,
                self_delivery_fee: selfDeliveryFormData.deliveryFee,
                fare_version: isFareV2.value ? "v2" : "",
                user_coupon_ids: (_selectedCoupon$value = selectedCoupon.value) !== null && _selectedCoupon$value !== void 0 && _selectedCoupon$value.id && isFareV2.value ? [(_selectedCoupon$value2 = selectedCoupon.value) === null || _selectedCoupon$value2 === void 0 ? void 0 : _selectedCoupon$value2.id] : []
              });
            case 4:
              calcRes = _context3.sent;
              if (calcRes.isOK && calcRes.data) {
                grandTotal.value = calcRes.data.customer_total_display;
                couponTotal.value = ((_calcRes$data = calcRes.data) === null || _calcRes$data === void 0 ? void 0 : _calcRes$data.coupon_total) || 0;
                totalPriceExcTax.value = ((_calcRes$data2 = calcRes.data) === null || _calcRes$data2 === void 0 ? void 0 : _calcRes$data2.dishes_total_pre_tax) || 0;
                feeList.value = handleFeeDetail({
                  fare: calcRes.data,
                  is_fare_v2: isFareV2.value,
                  currency_setting: shopStore.getShopData.currency_setting
                });
              } else if (calcRes.code === DISHES_ORDER_ITEM_INVALID) {
                dishes = ((_calcRes$data3 = calcRes.data) === null || _calcRes$data3 === void 0 ? void 0 : _calcRes$data3.failed_dishes_items) || [];
                handleShowOrderFailDialog(dishesItems, dishes);
              } else if ([COUPON_NOT_MATCH_DISHES, COUPON_NOT_MATCH_MINIMUM_AMOUNT].includes(calcRes.code)) {
                // 优惠券不符合使用要求，去掉优惠券
                if (calcRes.code === COUPON_NOT_MATCH_DISHES) {
                  showToast(t("couponNotMatchDishesTips"), 3000);
                } else if (calcRes.code === COUPON_NOT_MATCH_MINIMUM_AMOUNT) {
                  showToast(t("couponNotMatchMinimumAmountTips"), 3000);
                }
                cartStore.setCoupon(null);
              } else {
                showToast(calcRes.msg || t("failed"), 3000);
              }
              isCalced.value = true;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _calcDeliveryOrder.apply(this, arguments);
    }
    var debounceCalcDeliveryOrder = debounce(calcDeliveryOrder, 800);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _addressStore$getSele, _addressStore$getSele2, _shopData$value, getUserCouponListRes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            readAndRemoveSessionStorage();
            if (deliveryMethod.value === "self_delivery") {
              // 计算自配送数据
              deliveryDistance.value = getSelfDeliveryDistance();
              getDeliveryFeeAndTime({
                lat: (_addressStore$getSele = addressStore.getSelectedAddress) === null || _addressStore$getSele === void 0 || (_addressStore$getSele = _addressStore$getSele.location) === null || _addressStore$getSele === void 0 || (_addressStore$getSele = _addressStore$getSele.coordinate) === null || _addressStore$getSele === void 0 ? void 0 : _addressStore$getSele.latitude,
                lng: (_addressStore$getSele2 = addressStore.getSelectedAddress) === null || _addressStore$getSele2 === void 0 || (_addressStore$getSele2 = _addressStore$getSele2.location) === null || _addressStore$getSele2 === void 0 || (_addressStore$getSele2 = _addressStore$getSele2.coordinate) === null || _addressStore$getSele2 === void 0 ? void 0 : _addressStore$getSele2.longitude
              }).then(function (res) {
                selfDeliveryFormData.deliveryFee = res.fee;
                selfDeliveryFormData.deliveryTime = res.time;
                selfDeliveryFormData.startingFee = res.startingFee;
              });

              // deliveryPackingFee.value =
              //   shopData.value?.self_delivery_setting?.package_fee || 0;
            }
            if (deliveryMethod.value === "self_pick_up") {
              pickupDistance.value = getSelfPickUpDistance();
              mealPrepareTime.value = ((_shopData$value = shopData.value) === null || _shopData$value === void 0 || (_shopData$value = _shopData$value.self_pickup_setting) === null || _shopData$value === void 0 ? void 0 : _shopData$value.meal_prepare_time) || 0;
            }

            // const getUserCouponListRes = getUnusedUserCouponListRes;
            _context.next = 5;
            return getUserCouponList({
              company_id: getSupplyId(),
              available_shop_id: shopStore.getShopId,
              status: "unused",
              user_id: getUserId(),
              search_mode: 1
            });
          case 5:
            getUserCouponListRes = _context.sent;
            if (getUserCouponListRes.isOK && getUserCouponListRes.data) {
              userCouponList.value = getUserCouponListRes.data.items;
            }
            _context.next = 9;
            return calcDeliveryOrder();
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var totalPriceExcTax = ref(0);
    function handleSelectPaymentMethod(val) {
      paymentMethod.value = val;
    }
    var showSelectCouponList = ref(false);
    function handleShowSelectCouponList() {
      showSelectCouponList.value = true;
    }
    var scrollWrap = ref();
    var contactPerson = ref();
    var showSubmitErrorMsg = ref(false);
    var showConfirmShopDialog = ref(false);
    function handleConfirmShop() {
      var _paymentMethod$value5, _paymentMethodRef$val3;
      if (contactPersonErrorMsg.value) {
        var pageNavBar = document.getElementById("page-nav-bar");
        if (scrollWrap.value && contactPerson.value && pageNavBar) {
          scrollWrap.value.scrollTo({
            top: contactPerson.value.offsetTop - pageNavBar.offsetHeight,
            behavior: "smooth"
          });
        }
        showSubmitErrorMsg.value = true;
        return;
      }
      if (((_paymentMethod$value5 = paymentMethod.value) === null || _paymentMethod$value5 === void 0 ? void 0 : _paymentMethod$value5.method) === "balance" && userStore.getWallet < computedGrandTotal.value && ((_paymentMethodRef$val3 = paymentMethodRef.value) === null || _paymentMethodRef$val3 === void 0 ? void 0 : _paymentMethodRef$val3.onlinePaymentOptions.length) > 0 && allowReload.value) {
        // 跳转去充值页
        setSessionStorage();
        routerPush({
          name: "Recharge",
          query: {
            redirect: "confirm_order"
          }
        });
        return;
      }
      showConfirmShopDialog.value = true;
    }
    function handleClickDisabled() {
      if (isShowPrivacyPolicyAndUserTerms.value && !(isPrivacyPolicyChecked.value && isUserTermsChecked.value)) {
        Notify.error(t("pleaseFillInOrAgree"));
      }
    }
    function handleShowOrderFailTips(msg) {
      Dialog.confirm({
        title: t("cannotSubmitOrder"),
        desc: msg,
        okText: t("gotIt"),
        withoutCancel: true
      });
    }
    var failedDishes = ref([]);
    var failedDishesShow = ref(false);
    function handleShowOrderFailDialog(dishesItems, failedItems) {
      var failedSpuIds = [];
      failedItems.forEach(function (item) {
        var target = dishesItems.find(function (o) {
          return o.item_id === item.item_id;
        });
        if (target) {
          failedSpuIds.push(target.spu_id);
        }
      });
      failedDishes.value = cartList.value.filter(function (item) {
        return failedSpuIds.includes(item.id);
      }).map(function (item) {
        var _item$imgs;
        return {
          spu_id: item.id,
          id: item.UUKey,
          name: item.name,
          img: ((_item$imgs = item.imgs) === null || _item$imgs === void 0 ? void 0 : _item$imgs[0]) || "",
          quantity: item.num,
          attrs: calcDishTagList(item).map(function (item) {
            return item.value;
          }).filter(Boolean),
          price: item.selectedPrice
        };
      });
      failedDishesShow.value = true;
    }
    function onFailDishesConfirm() {
      failedDishes.value.forEach(function (item) {
        var targetIndex = cartList.value.findIndex(function (c) {
          return c.id === item.spu_id;
        });
        if (targetIndex !== -1) {
          handleUpdateCount(targetIndex, 0);
        }
      });
    }

    // 创建自提/自配送订单
    var needCalAmount = ref(true);
    function handleCreateOrder() {
      return _handleCreateOrder.apply(this, arguments);
    }
    function _handleCreateOrder() {
      _handleCreateOrder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var dishesItemsData, creatOrderReq, _selectedAddress$valu4, _selectedAddress$valu5, _selectedAddress$valu6, _selectedAddress$valu7, _selectedAddress$valu8, _selectedAddress$valu9, _selectedAddress$valu10, _selectedAddress$valu11, _selectedAddress$valu12, _selectedAddress$valu13, _selectedAddress$valu14, result, _paymentMethodValue$s, _paymentMethodValue$s2, _paymentMethodValue$c, _paymentMethodValue$c2, paymentMethodValue, success_url, cancel_url, successUrl, cancelUrl, firstName, lastName, state, city, zipCode, address, _selectedAddress$valu15, _selectedAddress$valu16, _selectedAddress$valu17, _selectedAddress$valu18, _selectedAddress$valu19, _selectedAddress$valu20, _ref3, _ref4, _result$data, dishes;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              showConfirmShopDialog.value = false;
              if (!isSubmit.value) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              isSubmit.value = true;
              dishesItemsData = createOrderDishesItems(cloneDeep(cartList.value));
              creatOrderReq = {
                shop_id: shopStore.getShopId,
                delivery_method: deliveryMethod.value,
                payment_method: "online_payment",
                need_cutlery: true,
                // 原型暂时没有表单
                order_type: "delivery",
                dishes_items: dishesItemsData,
                fare_version: isFareV2.value ? "v2" : ""
              };
              if (selectedCoupon.value) {
                creatOrderReq.discounts = [{
                  discount_info: {
                    amount: couponReduceAmount.value,
                    value: selectedCoupon.value.id,
                    currency: currency.value
                  },
                  discount_type: "coupon"
                }];
              }
              if (selectedVoucherCode.value) {
                creatOrderReq.gift_card_info = {
                  card_number: selectedVoucherCode.value.card_number,
                  amount: voucherCodeReduceAmount.value
                };
              }
              if (selectedPoints.value) {
                creatOrderReq.points_info = {
                  points_redeemed: convertPrice2Points(priceUtil.tranferBaseUnitToPrice(pointsReduceAmount.value, currency.value), selectedPoints.value),
                  amount: pointsReduceAmount.value
                };
              }
              if (deliveryMethod.value === "self_delivery") {
                creatOrderReq = _objectSpread(_objectSpread({}, creatOrderReq), {
                  pick_up_time: "now",
                  delivery_address: {
                    city: (_selectedAddress$valu4 = selectedAddress.value) === null || _selectedAddress$valu4 === void 0 || (_selectedAddress$valu4 = _selectedAddress$valu4.location) === null || _selectedAddress$valu4 === void 0 ? void 0 : _selectedAddress$valu4.city,
                    coordinate: (_selectedAddress$valu5 = selectedAddress.value) === null || _selectedAddress$valu5 === void 0 || (_selectedAddress$valu5 = _selectedAddress$valu5.location) === null || _selectedAddress$valu5 === void 0 ? void 0 : _selectedAddress$valu5.coordinate,
                    detail: (_selectedAddress$valu6 = selectedAddress.value) === null || _selectedAddress$valu6 === void 0 || (_selectedAddress$valu6 = _selectedAddress$valu6.location) === null || _selectedAddress$valu6 === void 0 ? void 0 : _selectedAddress$valu6.detail,
                    street: (_selectedAddress$valu7 = selectedAddress.value) === null || _selectedAddress$valu7 === void 0 || (_selectedAddress$valu7 = _selectedAddress$valu7.location) === null || _selectedAddress$valu7 === void 0 ? void 0 : _selectedAddress$valu7.street,
                    site: (_selectedAddress$valu8 = selectedAddress.value) === null || _selectedAddress$valu8 === void 0 || (_selectedAddress$valu8 = _selectedAddress$valu8.location) === null || _selectedAddress$valu8 === void 0 ? void 0 : _selectedAddress$valu8.site,
                    postal_code: (_selectedAddress$valu9 = selectedAddress.value) === null || _selectedAddress$valu9 === void 0 || (_selectedAddress$valu9 = _selectedAddress$valu9.location) === null || _selectedAddress$valu9 === void 0 ? void 0 : _selectedAddress$valu9.postcode,
                    state: (_selectedAddress$valu10 = selectedAddress.value) === null || _selectedAddress$valu10 === void 0 || (_selectedAddress$valu10 = _selectedAddress$valu10.location) === null || _selectedAddress$valu10 === void 0 ? void 0 : _selectedAddress$valu10.state,
                    name: (_selectedAddress$valu11 = selectedAddress.value) === null || _selectedAddress$valu11 === void 0 ? void 0 : _selectedAddress$valu11.contact_name,
                    mobile: (_selectedAddress$valu12 = selectedAddress.value) === null || _selectedAddress$valu12 === void 0 ? void 0 : _selectedAddress$valu12.contact_number
                  },
                  self_delivery_at: selfDeliveryFormData.deliveryTime,
                  self_delivery_fee: selfDeliveryFormData.deliveryFee,
                  customer: {
                    name: (_selectedAddress$valu13 = selectedAddress.value) === null || _selectedAddress$valu13 === void 0 ? void 0 : _selectedAddress$valu13.contact_name,
                    mobile: (_selectedAddress$valu14 = selectedAddress.value) === null || _selectedAddress$valu14 === void 0 ? void 0 : _selectedAddress$valu14.contact_number,
                    remark: customerRemark.value
                  }
                });
              } else {
                creatOrderReq = _objectSpread(_objectSpread({}, creatOrderReq), {
                  pick_up_time: pickUpTime.value,
                  customer: {
                    name: customerName.value,
                    mobile: customerMobile.value,
                    remark: customerRemark.value
                  }
                });
              }
              showLoading();
              _context4.prev = 11;
              _context4.next = 14;
              return createDeliveryOrder(creatOrderReq);
            case 14:
              result = _context4.sent;
              if (result.isOK && result.data) {
                paymentMethodValue = paymentMethod.value;
                success_url = (_paymentMethodValue$s = (_paymentMethodValue$s2 = paymentMethodValue.success_url) === null || _paymentMethodValue$s2 === void 0 ? void 0 : _paymentMethodValue$s2.replace("${order_id}", result.data.order_id)) !== null && _paymentMethodValue$s !== void 0 ? _paymentMethodValue$s : "";
                cancel_url = (_paymentMethodValue$c = (_paymentMethodValue$c2 = paymentMethodValue.cancel_url) === null || _paymentMethodValue$c2 === void 0 ? void 0 : _paymentMethodValue$c2.replace("${order_id}", result.data.order_id)) !== null && _paymentMethodValue$c !== void 0 ? _paymentMethodValue$c : "";
                successUrl = paymentMethodValue.needRedirect ? "".concat(process.env.VUE_APP_PAYMENT_API_URI, "/payment/v1/callback/redirection?url=").concat(success_url) : success_url;
                cancelUrl = paymentMethodValue.needRedirect ? "".concat(process.env.VUE_APP_PAYMENT_API_URI, "/payment/v1/callback/redirection?url=").concat(cancel_url) : cancel_url;
                firstName = "";
                lastName = "";
                state = "";
                city = "";
                zipCode = "";
                address = "";
                if (deliveryMethod.value === "self_delivery") {
                  _ref3 = (_selectedAddress$valu19 = selectedAddress.value) !== null && _selectedAddress$valu19 !== void 0 && _selectedAddress$valu19.contact_name ? (_selectedAddress$valu20 = selectedAddress.value) === null || _selectedAddress$valu20 === void 0 ? void 0 : _selectedAddress$valu20.contact_name.split(" ") : [];
                  _ref4 = _slicedToArray(_ref3, 2);
                  firstName = _ref4[0];
                  lastName = _ref4[1];
                  city = (_selectedAddress$valu15 = selectedAddress.value) === null || _selectedAddress$valu15 === void 0 || (_selectedAddress$valu15 = _selectedAddress$valu15.location) === null || _selectedAddress$valu15 === void 0 ? void 0 : _selectedAddress$valu15.city;
                  state = (_selectedAddress$valu16 = selectedAddress.value) === null || _selectedAddress$valu16 === void 0 || (_selectedAddress$valu16 = _selectedAddress$valu16.location) === null || _selectedAddress$valu16 === void 0 ? void 0 : _selectedAddress$valu16.state;
                  zipCode = (_selectedAddress$valu17 = selectedAddress.value) === null || _selectedAddress$valu17 === void 0 || (_selectedAddress$valu17 = _selectedAddress$valu17.location) === null || _selectedAddress$valu17 === void 0 ? void 0 : _selectedAddress$valu17.postcode;
                  address = (_selectedAddress$valu18 = selectedAddress.value) === null || _selectedAddress$valu18 === void 0 || (_selectedAddress$valu18 = _selectedAddress$valu18.location) === null || _selectedAddress$valu18 === void 0 ? void 0 : _selectedAddress$valu18.street;
                }
                createOnlinePay({
                  srv: createDeliveryOrderOnlinePay,
                  orderId: result.data.order_id,
                  paymentChannel: (selectedVoucherCode.value || selectedPoints.value) && computedGrandTotal.value === 0 ? {
                    value: undefined
                  } : paymentMethodValue,
                  successUrl: successUrl,
                  cancelUrl: cancelUrl,
                  onSuccess: function onSuccess() {
                    // 订单提交成功后，清除购物车/备注/其它临时数据
                    cartStore.setCoupon(null);
                    cartStore.clear();
                    orderListStore.setOrders([]);
                    needCalAmount.value = false;
                  },
                  onError: function onError() {
                    showToast(t("createOnlinePayFailed"));
                  },
                  redirectOrderDetailUrl: "#/order_detail?id=".concat(result.data.order_id, "&callback=1"),
                  shopname: shopStore.getShopName,
                  addressData: {
                    firstName: firstName,
                    lastName: lastName,
                    state: state,
                    city: city,
                    zipCode: zipCode,
                    address: address
                  },
                  paymentshubPayPageUrl: process.env.VUE_APP_PAYMENTSHUB_PAY_PAGE_URL,
                  paymentshubRedirectUrl: process.env.VUE_APP_PAYMENTSHUB_REDIRECT_URL,
                  otherParams: {
                    staging: !isProd,
                    onConfirm: function onConfirm(cb) {
                      Dialog.confirm({
                        title: t("warning"),
                        desc: t("sureToClose"),
                        okText: t("yes"),
                        cancelText: t("no"),
                        onOk: function onOk() {
                          cb === null || cb === void 0 || cb();
                          window.location.reload();
                        }
                      });
                    },
                    onReady: function onReady() {
                      hideLoading();
                    }
                  }
                });
              } else {
                hideLoading();
                if (result.code === SHOP_UNSUPPORT_DELIVERY) {
                  handleShowOrderFailTips(t("thisShopDoesUnsupportDelivery"));
                } else if (result.code === SHOP_BUSY) {
                  handleShowOrderFailTips(t("shopBusyDesc"));
                } else if (result.code === SHOP_NOT_IN_BUSINESS_STATUS) {
                  handleShowOrderFailTips(t("storeIsNotInBusinessStatus"));
                } else if (result.code === DISHES_ORDER_ITEM_INVALID) {
                  dishes = ((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.failed_dishes_items) || [];
                  handleShowOrderFailDialog(dishesItemsData, dishes);
                } else if (result.code === VOUCHER_CODE_CANNOT_USE) {
                  handleShowOrderFailTips(t("invalidVoucherCode"));
                } else {
                  showToast(t("orderFailed"));
                }
              }
              _context4.next = 23;
              break;
            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](11);
              console.error(_context4.t0);
              hideLoading();
              showToast(t("orderFailed"));
            case 23:
              isSubmit.value = false;
            case 24:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[11, 18]]);
      }));
      return _handleCreateOrder.apply(this, arguments);
    }
    function handleClickAddress() {
      // if (deliveryMethod.value === "self_delivery") {
      //   routerPush({
      //     name: "AddressList",
      //     query: {
      //       toName: "Menu",
      //     },
      //   });
      // } else if (deliveryMethod.value === "self_pick_up") {
      //   routerPush({
      //     name: "StoreList",
      //     query: {
      //       toName: "Menu",
      //     },
      //   });
      // }
    }

    // 页面后退
    function handlePageBack() {
      if (route.query.back_to_menu) {
        // 可能出现的场景: 充值完成回到本页,需指定后退时回到menu页
        routerPush({
          name: "Menu"
        });
      } else {
        routerBack();
      }
    }

    // 费用结构新增v2
    watch(function () {
      return selectedCoupon.value;
    }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(isFareV2.value && needCalAmount.value)) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return calcDeliveryOrder();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));

    // 缓存页面会话数据，以便从充值页回来能够保持订单确认页的状态（充值页有可能跳转第三方支付页）
    function setSessionStorage() {
      Persistent.setSession(SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE, true);
      Persistent.setSession(SESSION_KEY_CUSTOMER_REMARK, customerRemark.value);
      Persistent.setSession(SESSION_KEY_SELECTED_PAYMENT_METHOD, paymentMethod.value);
      Persistent.setSession(SESSION_KEY_IS_PRIVACY_POLICY_CHECKED, isPrivacyPolicyChecked.value);
      Persistent.setSession(SESSION_KEY_IS_USER_TERMS_CHECKED, isUserTermsChecked.value);
      Persistent.setSession(SESSION_KEY_CART_COUPON, cartStore.getCoupon);
      Persistent.setSession(SESSION_KEY_CART_VOUCHER_CODE_DETAIL, cartStore.getVoucherCodeDetail);
      Persistent.setSession(SESSION_KEY_CART_VOUCHER_CODE, cartStore.getVoucherCode);
      Persistent.setSession(SESSION_KEY_CART_POINTS, cartStore.getPoints);
    }

    // 读取页面会话数据，并清空对应sessionStorage
    function readAndRemoveSessionStorage() {
      customerRemark.value = Persistent.getSession(SESSION_KEY_CUSTOMER_REMARK) || "";
      paymentMethod.value = Persistent.getSession(SESSION_KEY_SELECTED_PAYMENT_METHOD) || null;
      isPrivacyPolicyChecked.value = Persistent.getSession(SESSION_KEY_IS_PRIVACY_POLICY_CHECKED) || false;
      isUserTermsChecked.value = Persistent.getSession(SESSION_KEY_IS_USER_TERMS_CHECKED) || false;
      cartStore.setCoupon(Persistent.getSession(SESSION_KEY_CART_COUPON) || null);
      cartStore.setVoucherCodeDetail(Persistent.getSession(SESSION_KEY_CART_VOUCHER_CODE_DETAIL) || null);
      cartStore.setVoucherCode(Persistent.getSession(SESSION_KEY_CART_VOUCHER_CODE) || null);
      cartStore.setPoints(Persistent.getSession(SESSION_KEY_CART_POINTS) || null);
      Persistent.removeSession(SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE);
      Persistent.removeSession(SESSION_KEY_CUSTOMER_REMARK);
      Persistent.removeSession(SESSION_KEY_SELECTED_PAYMENT_METHOD);
      Persistent.removeSession(SESSION_KEY_IS_PRIVACY_POLICY_CHECKED);
      Persistent.removeSession(SESSION_KEY_IS_USER_TERMS_CHECKED);
      Persistent.removeSession(SESSION_KEY_CART_COUPON);
      Persistent.removeSession(SESSION_KEY_CART_VOUCHER_CODE_DETAIL);
      Persistent.removeSession(SESSION_KEY_CART_VOUCHER_CODE);
      Persistent.removeSession(SESSION_KEY_CART_POINTS);
      var cartStorageData = cartStore.getCartStorage();
      if (cartStorageData) {
        if (cartStorageData.shop_id === shopStore.getShopId && cartStorageData.cart) {
          cartStore.setCart(cartStorageData.cart);
        }
        cartStore.removeCartStorage();
      }
    }
    function linkTo(link) {
      if (link) {
        window.open(link, "_blank");
      }
    }
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: _ctx.$t('orderConfirmation'),
        "on-back": handlePageBack,
        "is-yellow-bg": "",
        "show-footer": ""
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("total")), 1), _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(computedGrandTotal.value, currency.value)), 1)]), isShowPrivacyPolicyAndUserTerms.value ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createVNode(Checkbox, {
            value: isPrivacyPolicyChecked.value,
            "onUpdate:value": _cache[7] || (_cache[7] = function ($event) {
              return isPrivacyPolicyChecked.value = $event;
            })
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_53, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("IHaveReadAndAgreeTo")) + " ", 1), _createElementVNode("span", {
                class: "user-terms-link",
                onClick: _cache[6] || (_cache[6] = _withModifiers(function ($event) {
                  return linkTo("".concat(_unref(orderpinH5Host), "/views/privacy_policy_").concat(privacyPolicyAndUserTermsLang.value, ".html"));
                }, ["stop"]))
              }, _toDisplayString(_ctx.$t("privacyPolicy")), 1)])];
            }),
            _: 1
          }, 8, ["value"]), _createVNode(Checkbox, {
            value: isUserTermsChecked.value,
            "onUpdate:value": _cache[9] || (_cache[9] = function ($event) {
              return isUserTermsChecked.value = $event;
            })
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("IHaveReadAndAgreeTo")) + " ", 1), _createElementVNode("span", {
                class: "user-terms-link",
                onClick: _cache[8] || (_cache[8] = _withModifiers(function ($event) {
                  return linkTo("".concat(_unref(orderpinH5Host), "/views/user_terms_").concat(privacyPolicyAndUserTermsLang.value, ".html"));
                }, ["stop"]))
              }, _toDisplayString(_ctx.$t("userTerms")), 1)])];
            }),
            _: 1
          }, 8, ["value"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_55, [_createVNode(Button, {
            class: "bottom-button",
            disabled: isSubmitButtonDisabled.value,
            onClick: handleConfirmShop,
            onDisabledClick: handleClickDisabled
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(submitButtonText.value), 1)];
            }),
            _: 1
          }, 8, ["disabled"])])])];
        }),
        default: _withCtx(function () {
          var _unref$getShopData, _selectedAddress$valu, _selectedAddress$valu2;
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
            ref_key: "scrollWrap",
            ref: scrollWrap,
            class: "confirm-order-content"
          }, [_createElementVNode("div", {
            class: "link-panel",
            onClick: handleClickAddress
          }, [_createElementVNode("div", _hoisted_2, [_unref(supplierStore).getSupplierPickupImage && _unref(supplierStore).getSupplierDeliveryImage ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "icon-pack-drink",
            src: deliveryMethod.value === 'self_pick_up' ? _unref(supplierStore).getSupplierPickupImage : _unref(supplierStore).getSupplierDeliveryImage,
            alt: ""
          }, null, 8, _hoisted_3)) : (_openBlock(), _createBlock(SvgIcon, {
            key: 1,
            class: "icon-pack-drink",
            name: deliveryMethod.value === 'self_pick_up' ? 'pickup' : 'delivery'
          }, null, 8, ["name"])), deliveryMethod.value === 'self_pick_up' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref(shopStore).getShopName), 1), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("span", null, [_createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatDistance)(pickupDistance.value)), 1), _cache[10] || (_cache[10] = _createElementVNode("span", {
            class: "splitor"
          }, null, -1))], 512), [[_vShow, !isNaN(pickupDistance.value)]]), _createElementVNode("span", null, _toDisplayString(_unref(formatLocation)(((_unref$getShopData = _unref(shopStore).getShopData) === null || _unref$getShopData === void 0 ? void 0 : _unref$getShopData.location) || {})), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("pickupAtStoreAroundN", [formatedPickupAt.value])), 1)])])) : _createCommentVNode("", true), deliveryMethod.value === 'self_delivery' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(((_selectedAddress$valu = selectedAddress.value) === null || _selectedAddress$valu === void 0 ? void 0 : _selectedAddress$valu.label) || ""), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(formatLocation)(((_selectedAddress$valu2 = selectedAddress.value) === null || _selectedAddress$valu2 === void 0 ? void 0 : _selectedAddress$valu2.location) || {})), 1), _withDirectives(_createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("deliveryAboutNMinutes", [formatedSelfDeliveryTime.value])), 1)], 512), [[_vShow, formatedSelfDeliveryTime.value > 0]])])) : _createCommentVNode("", true)])]), deliveryMethod.value === 'self_pick_up' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "contactPerson",
            ref: contactPerson
          }, [_createVNode(_component_Gap, {
            h: 0.1
          }), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("contactPerson")), 1), _withDirectives(_createElementVNode("div", {
            class: "header--error"
          }, " (" + _toDisplayString(contactPersonErrorMsg.value) + ") ", 513), [[_vShow, contactPersonErrorMsg.value && showSubmitErrorMsg.value]])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[11] || (_cache[11] = _createElementVNode("div", {
            class: "form-item-label form-item--require"
          }, null, -1)), _createElementVNode("div", _hoisted_17, [_createVNode(Input, {
            modelValue: customerName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return customerName.value = $event;
            }),
            placeholder: _ctx.$t('name'),
            "self-type": "borderBottom"
          }, null, 8, ["modelValue", "placeholder"])])]), _createElementVNode("div", _hoisted_18, [_cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "form-item-label form-item--require"
          }, null, -1)), _createElementVNode("div", _hoisted_19, [_createVNode(Input, {
            modelValue: customerMobile.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return customerMobile.value = $event;
            }),
            placeholder: _ctx.$t('tel'),
            "self-type": "borderBottom"
          }, null, 8, ["modelValue", "placeholder"])])])])])], 512)) : _createCommentVNode("", true), _createVNode(_component_Gap, {
            h: 0.1
          }), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("orderItems")), 1), _createVNode(CartItems, {
            "cart-list": cartList.value,
            "onUpdate:cartCount": handleUpdateCount
          }, null, 8, ["cart-list"]), _createElementVNode("div", _hoisted_22, [_createVNode(Input, {
            modelValue: customerRemark.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return customerRemark.value = $event;
            }),
            class: "remark-input",
            maxlength: "50",
            placeholder: _ctx.$t('addYourRequest')
          }, null, 8, ["modelValue", "placeholder"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feeList.value, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.key,
              class: "detial-info"
            }, [_createElementVNode("div", _hoisted_23, _toDisplayString(item.label), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(item.value), 1)]);
          }), 128)), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(SvgIcon, {
            name: "voucher",
            size: 20,
            class: "info-label-img"
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t("voucher")), 1)]), _createElementVNode("div", {
            class: "info-value",
            onClick: handleShowSelectCouponList
          }, [selectedCoupon.value || selectedVoucherCode.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, " -" + _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(selectedVoucherCode.value ? voucherCodeReduceAmount.value : couponReduceAmount.value, currency.value)), 1)])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [canuseSelectCouponList.value.length || voucherCodeDetail.value ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t("nVouchers", [canuseSelectCouponList.value.length + (voucherCodeDetail.value ? 1 : 0)])), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.$t("noApplicableVouchers")), 1))], 64)), _createVNode(SvgIcon, {
            class: "info-value-arrow",
            name: "arrow_right",
            size: 16
          })])]), _unref(convertPoint2Price)(_unref(userStore).getPoints, _unref(supplierStore).getPointsPaymentRule) > 0 ? (_openBlock(), _createBlock(PayWithPoints, {
            key: 0,
            class: "detial-info",
            "reduce-amount": pointsReduceAmount.value,
            "is-not-need": selectedVoucherCode.value
          }, null, 8, ["reduce-amount", "is-not-need"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("total")), 1), _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(computedGrandTotal.value, currency.value)), 1)])])]), _withDirectives(_createVNode(_component_Gap, {
            h: 0.1
          }, null, 512), [[_vShow, !((selectedVoucherCode.value || selectedPoints.value) && computedGrandTotal.value === 0)]]), _withDirectives(_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("paymentMethods")), 1), _createElementVNode("div", _hoisted_36, [_createVNode(PaymentMethodVue, {
            ref_key: "paymentMethodRef",
            ref: paymentMethodRef,
            "delivery-method": deliveryMethod.value,
            "need-show-more": true,
            "default-value": paymentMethod.value,
            "invalid-method-list": (selectedVoucherCode.value || selectedPoints.value) && computedGrandTotal.value > 0 ? ['cod'] : null,
            onChange: handleSelectPaymentMethod
          }, null, 8, ["delivery-method", "default-value", "invalid-method-list"])])], 512), [[_vShow, !((selectedVoucherCode.value || selectedPoints.value) && computedGrandTotal.value === 0)]]), _createVNode(PoweredBy, {
            class: "order-by"
          })], 512), _createVNode(SelectCouponList, {
            show: showSelectCouponList.value,
            "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
              return showSelectCouponList.value = $event;
            }),
            "coupon-list": selectCouponList.value,
            "is-not-need-voucher-code": selectedPoints.value
          }, null, 8, ["show", "coupon-list", "is-not-need-voucher-code"]), _createVNode(Common, {
            visible: showConfirmShopDialog.value,
            "onUpdate:visible": _cache[4] || (_cache[4] = function ($event) {
              return showConfirmShopDialog.value = $event;
            }),
            title: _ctx.$t('confirmOrderInformation'),
            "ok-text": _ctx.$t('orderNow'),
            "show-close-btn": "",
            "without-cancel": "",
            "show-bottom-shadow": "",
            "on-ok": handleCreateOrder
          }, {
            content: _withCtx(function () {
              var _unref$getShopData2, _selectedAddress$valu3;
              return [_createElementVNode("div", _hoisted_37, [deliveryMethod.value === 'self_pick_up' ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", null, _toDisplayString(customerName.value), 1), _createElementVNode("span", null, _toDisplayString(customerMobile.value), 1)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(_unref(shopStore).getShopName), 1), _createVNode(PreparingInfo, {
                class: "ready"
              }), _createElementVNode("div", null, _toDisplayString(_unref(formatLocation)(((_unref$getShopData2 = _unref(shopStore).getShopData) === null || _unref$getShopData2 === void 0 ? void 0 : _unref$getShopData2.location) || {})), 1), _withDirectives(_createElementVNode("div", {
                class: "delivery-distance"
              }, _toDisplayString(_unref(formatDistance)(pickupDistance.value)), 513), [[_vShow, !isNaN(pickupDistance.value)]])])])) : _createCommentVNode("", true), deliveryMethod.value === 'self_delivery' ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("span", _hoisted_44, _toDisplayString(_unref(shopStore).getShopName), 1), _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(formatDistance)(deliveryDistance.value)), 1)]), _createVNode(PreparingInfo, {
                class: "ready"
              }), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("span", null, _toDisplayString(selectedAddress.value.contact_name), 1), _createElementVNode("span", null, _toDisplayString(selectedAddress.value.contact_number), 1)]), _createElementVNode("div", null, _toDisplayString(_unref(formatLocation)(((_selectedAddress$valu3 = selectedAddress.value) === null || _selectedAddress$valu3 === void 0 ? void 0 : _selectedAddress$valu3.location) || {})), 1)])])) : _createCommentVNode("", true)])];
            }),
            _: 1
          }, 8, ["visible", "title", "ok-text"])]), _createVNode(OutOfStockDialog, {
            visible: failedDishesShow.value,
            "onUpdate:visible": _cache[5] || (_cache[5] = function ($event) {
              return failedDishesShow.value = $event;
            }),
            dishes: failedDishes.value,
            onConfirm: onFailDishesConfirm
          }, null, 8, ["visible", "dishes"])];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};